import { render } from "./TrustSet.vue?vue&type=template&id=2726d264&scoped=true"
import script from "./TrustSet.vue?vue&type=script&lang=js"
export * from "./TrustSet.vue?vue&type=script&lang=js"

import "./TrustSet.vue?vue&type=style&index=0&id=2726d264&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2726d264"]])

export default __exports__